import React, { useState, useEffect, useRef } from 'react'
import AliceCarousel from 'react-alice-carousel';
import PagesHeader from '../common/components/PagesHeader'
import IconTextCard from '../common/components/IconTextCard'
import MortgageRepayment from "website/how-to-apply/mortgage-repayment.svg"
import BorrowingCapacity from "website/how-to-apply/borrowing-capacity.svg"
import Equity from "website/how-to-apply/equity.svg"
import HomeDeposit from "website/how-to-apply/home-deposit.svg"
import Offset from "website/how-to-apply/offset.svg"
import Refinance from "website/how-to-apply/refinance.svg"
import StampDuty from "website/how-to-apply/stamp-duty.svg"
import GenericIcon from 'components/GenericIcon'

const MortgageCalculatorsContainer = () => {
  const [isDesktop, setIsDesktop] = useState(true);
  const carouselRef = useRef(null);
  const responsive = {
    0: { items: 1 },
    568: { items: 2 },
    1024: { items: 3 },
  };

  useEffect(() => {
    const handleResize = () => {
      const displayDesktopVersion = window.innerWidth > 576;
      setIsDesktop(displayDesktopVersion);

      const wrapper = carouselRef.current?.querySelector(".alice-carousel__wrapper");
      if (!wrapper) {
        return;
      }

      wrapper.style.removeProperty("width");
      if (!displayDesktopVersion) {
        wrapper.style.width = "360px";
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const items = [
    <IconTextCard
      link='/calculators/mortgage-repayment'
      header='Mortgage repayment'
      body='You can use our home loan payment calculator as a guide to what your mortgage repayments could be on a new home loan by entering your loan amount, loan term, interest rate and repayment frequency.'
      icon={<MortgageRepayment />}
      iconStyle={'pt-2'}
    />,
    <IconTextCard
      link='/calculators/borrowing-capacity'
      header='Borrowing capacity'
      body='This calculator will help you estimate the loan amount you can borrow based on your income and expenses, the value of the home you can afford and your mortgage monthly repayment.'
      icon={<BorrowingCapacity />}
    />,
    <IconTextCard
      link='/calculators/refinance-calculator'
      header='Refinance'
      body="The refinance calculator let's you do a mortgage comparison and estimate your savings if you are to refinance your home loan to Yard."
      icon={<Refinance />}
    />,
    <IconTextCard
      link='/calculators/offset-calculator'
      header='Offset'
      body="The offset home loan calculator allows you to estimate how much interest you can save by keeping your savings in an offset account."
      icon={<Offset />}
    />,
    <IconTextCard
      link='/calculators/home-deposit'
      header='Home deposit'
      body="You can use our home deposit calculator to estimate the upfront costs associated with buying a property - stamp duty and other buying costs."
      icon={<HomeDeposit />}
    />,
    <IconTextCard
      link='/calculators/stamp-duty'
      header='Stamp duty'
      body="The stamp duty calculator provides an estimate of stamp (transfer) duty and mortgage registration charges for each state based on your property purchase price."
      icon={<StampDuty />}
    />,
    <IconTextCard
      link='/calculators/home-equity'
      header='Equity'
      body="Home equity is the difference between your current property value and the outstanding balance on your home loan. Estimate your available equity using our home equity calculator."
      icon={<Equity />}
    />,
  ]

  return (
    <div className='mb-5'>
      <div className="jumbotron jumbotron-fluid jumbotron-fixed-height pt-0 pb-0 mb-4">
        <div className="container">
          <h3 className="text-center mb-3">Mortgage Calculators</h3>
          <div className='how-to-apply-page-body text-center'>
            Check out our range of handy calculators that take the hassle out of working out your mortgage repayments and how much you can borrow
          </div>
        </div>
      </div>
      <div className="mortgage-calculators-carousel" ref={carouselRef}>
        <AliceCarousel 
          infinite={true}
          disableDotsControls={isDesktop}
          responsive={responsive}
          items={items} 
          renderPrevButton={() => {
            return isDesktop ? <GenericIcon className='generic-icon' name='leftArrow' /> : null;
          }}
          renderNextButton={() => {
            return isDesktop ? <GenericIcon className='generic-icon' name='rightArrow' /> : null;
          }}
        />
      </div>
      <div className="text-center calc-buttons-container">
        <a className='btn btn-lg btn-green mr-3 p-0 view-all-calc-button' href="/calculators" >
          View all calculators
        </a>
        <a className='btn btn-lg btn-line-green apply-now-btn hover-light-green' href="/onboarding_funnel/new" >
          Apply now
        </a>
      </div>
    </div>

  )
}

export default MortgageCalculatorsContainer
